const mutations = {
  mutationOrganizations(state, payload) {
    state.organizations = payload;
  },

  mutationOrganization(state, payload) {
    state.organization = payload;
  },

  mutationOrganizationsProductCategories(state, payload) {
    state.product_categories = payload;
  },

  mutationOrganizationsTemplateRole(state, payload) {
    state.template_role = payload;
  },
};

export default mutations;
